import { z } from 'zod';
import { ZodStringToDate } from '../system/msc';
import { ProductModifierGroupSchema } from './modifiers';
export var ProductTypeEnum;
(function (ProductTypeEnum) {
    ProductTypeEnum["PHYSICAL_GOOD"] = "PHYSICAL_GOOD";
    ProductTypeEnum["PREPARED_FOOD"] = "PREPARED_FOOD";
    ProductTypeEnum["ELECTRONIC_DEVICE"] = "ELECTRONIC_DEVICE";
    ProductTypeEnum["CUSTOM_PRODUCT"] = "CUSTOM_PRODUCT";
})(ProductTypeEnum || (ProductTypeEnum = {}));
export const ProductTypeSchema = z.nativeEnum(ProductTypeEnum);
export const FetchProductTypeFromValue = (value) => {
    switch (value) {
        case ProductTypeEnum.PHYSICAL_GOOD:
            return ProductTypeEnum.PHYSICAL_GOOD;
        case ProductTypeEnum.PREPARED_FOOD:
            return ProductTypeEnum.PREPARED_FOOD;
        case ProductTypeEnum.ELECTRONIC_DEVICE:
            return ProductTypeEnum.ELECTRONIC_DEVICE;
        case ProductTypeEnum.CUSTOM_PRODUCT:
            return ProductTypeEnum.CUSTOM_PRODUCT;
        default:
            return ProductTypeEnum.PHYSICAL_GOOD;
    }
};
// storage amounts enum 16gb, 32gb, 64gb, 128gb, 256gb, 512gb, 1tb
export var StorageAmountEnum;
(function (StorageAmountEnum) {
    StorageAmountEnum["_16GB"] = "16GB";
    StorageAmountEnum["_32GB"] = "32GB";
    StorageAmountEnum["_64GB"] = "64GB";
    StorageAmountEnum["_128GB"] = "128GB";
    StorageAmountEnum["_256GB"] = "256GB";
    StorageAmountEnum["_512GB"] = "512GB";
    StorageAmountEnum["_1TB"] = "1TB";
})(StorageAmountEnum || (StorageAmountEnum = {}));
export const StorageAmountSchema = z.nativeEnum(StorageAmountEnum);
export var DeviceColorEnum;
(function (DeviceColorEnum) {
    DeviceColorEnum["BLACK"] = "BLACK";
    DeviceColorEnum["WHITE"] = "WHITE";
    DeviceColorEnum["SILVER"] = "SILVER";
    DeviceColorEnum["GOLD"] = "GOLD";
    DeviceColorEnum["ROSE_GOLD"] = "ROSE_GOLD";
    DeviceColorEnum["STARLIGHT"] = "STARLIGHT";
    DeviceColorEnum["MIDNIGHT"] = "MIDNIGHT";
    DeviceColorEnum["SPACE_GRAY"] = "SPACE_GRAY";
    DeviceColorEnum["GRAPHITE"] = "GRAPHITE";
    DeviceColorEnum["SPACE_BLACK"] = "SPACE_BLACK";
    DeviceColorEnum["BLUE"] = "BLUE";
    DeviceColorEnum["MIDNIGHT_BLUE"] = "MIDNIGHT_BLUE";
    DeviceColorEnum["SKY_BLUE"] = "SKY_BLUE";
    DeviceColorEnum["PACIFIC_BLUE"] = "PACIFIC_BLUE";
    DeviceColorEnum["STORM_BLUE"] = "STORM_BLUE";
    DeviceColorEnum["ULTRAMARINE"] = "ULTRAMARINE";
    DeviceColorEnum["GREEN"] = "GREEN";
    DeviceColorEnum["ALPINE_GREEN"] = "ALPINE_GREEN";
    DeviceColorEnum["TEAL"] = "TEAL";
    DeviceColorEnum["PURPLE"] = "PURPLE";
    DeviceColorEnum["DEEP_PURPLE"] = "DEEP_PURPLE";
    DeviceColorEnum["PINK"] = "PINK";
    DeviceColorEnum["RED"] = "RED";
    DeviceColorEnum["PRODUCT_RED"] = "PRODUCT_RED";
    DeviceColorEnum["YELLOW"] = "YELLOW";
    DeviceColorEnum["NATURAL_TITANIUM"] = "NATURAL_TITANIUM";
    DeviceColorEnum["DESERT_TITANIUM"] = "DESERT_TITANIUM";
    DeviceColorEnum["WHITE_TITANIUM"] = "WHITE_TITANIUM";
    DeviceColorEnum["BLACK_TITANIUM"] = "BLACK_TITANIUM";
})(DeviceColorEnum || (DeviceColorEnum = {}));
export const DeviceColorSchema = z.nativeEnum(DeviceColorEnum);
export const DEVICE_COLOR_VALUES = Object.values(DeviceColorEnum);
const ProductAttributesSchema = z.object({
    extraImages: z.string().array().default([]),
    isTaxable: z.boolean().default(true),
    isEnabled: z.boolean().default(true),
    ebtEligible: z.boolean().optional().default(false),
    tags: z.string().array().default([]),
    modifiers: z
        .object({
        groups: z.array(ProductModifierGroupSchema).default([]),
    })
        .optional(),
    /// optional fields
    preparedFood: z
        .object({
        ingredients: z.array(z.string()).default([]),
    })
        .optional(),
    physicalGood: z
        .object({
        soldByWeight: z.boolean().default(false),
        variablePrice: z.boolean().default(false),
        variablePriceLookupCode: z.string().optional(),
    })
        .optional(),
    electronicDevice: z
        .object({
        brand: z.string().nullable().optional(),
        model: z.string().nullable().optional(),
        storage: StorageAmountSchema.nullable().optional(),
        color: z.string().nullable().optional(),
        serialNumber: z.string().nullable().optional(),
        warrantyDays: z.number().nullable().optional(),
    })
        .optional(),
    posFavorite: z
        .object({
        isFavorite: z.boolean(),
        sortOrder: z.number(),
        color: z.string(),
        displayName: z.string(),
    })
        .optional(),
});
// End of Attributes
export const ProductDataSchema = z.object({
    id: z.string(),
    identifier: z.string(),
    name: z.string(),
    description: z.string(),
    cost: z.number(),
    price: z.number(),
    singleUse: z.boolean().default(false),
    sold: z.boolean().default(false),
    trackStockLevels: z.boolean().default(false),
    currentStockLevel: z.number().default(0),
    reorderStockLevel: z.number().default(0),
    type: ProductTypeSchema,
    defaultImageUrl: z.string(),
    itemCategory: z.string().default('GENERAL'), //default to "GENERAL"
    createdAt: ZodStringToDate,
    updatedAt: ZodStringToDate,
    deletedAt: z.nullable(ZodStringToDate),
    attributes: ProductAttributesSchema,
});
export const ProductStoreSchema = z.object({
    productList: ProductDataSchema.array().default([]),
    categories: z.string().array().default([]),
});
